import React from 'react';
import RuleViewer from './RuleViewer';
import OrderFlowRuleInput from './OrderFlowRuleInput';
import type { OrderFlowRuleReference } from 'domain-model/types/oms';

interface OrderFlowRuleConfiguratorProps {
  disabled: boolean;
  value: OrderFlowRuleReference[];
  name: string;
  onChange: (name: string, newValue: OrderFlowRuleReference[]) => void;
}

const OrderFlowRuleConfigurator: React.FC<OrderFlowRuleConfiguratorProps> = ({
  disabled,
  value,
  name,
  onChange,
}) => {
  return disabled ? (
    <RuleViewer value={value} />
  ) : (
    <OrderFlowRuleInput value={value} name={name} onChange={onChange} />
  );
};

export default OrderFlowRuleConfigurator;
